// @auto-index

import './styles.css'
import Section from './Section'

export { default as Section } from './Section'

export default Section
